/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Contract, ContractFactory, testMethod, callMethod, fetchContractState, ContractInstance, signExecuteMethod, addStdIdToFields, encodeContractFields, } from "@alephium/web3";
import { default as EmptyContractJson } from "../tests/Empty.ral.json";
import { getContractByCodeHash } from "./contracts";
class Factory extends ContractFactory {
    constructor() {
        super(...arguments);
        this.tests = {
            foo: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "foo", params, getContractByCodeHash);
            }),
        };
    }
    encodeFields(fields) {
        return encodeContractFields(addStdIdToFields(this.contract, fields), this.contract.fieldsSig, []);
    }
    at(address) {
        return new EmptyInstance(address);
    }
}
// Use this object to test and deploy the contract
export const Empty = new Factory(Contract.fromJson(EmptyContractJson, "", "6d6160ec29f40a382f2154aa04b223925d5004e9848b0ca6f74b2f5bc8762d22", []));
// Use this class to interact with the blockchain
export class EmptyInstance extends ContractInstance {
    constructor(address) {
        super(address);
        this.view = {
            foo: (params) => __awaiter(this, void 0, void 0, function* () {
                return callMethod(Empty, this, "foo", params === undefined ? {} : params, getContractByCodeHash);
            }),
        };
        this.transact = {
            foo: (params) => __awaiter(this, void 0, void 0, function* () {
                return signExecuteMethod(Empty, this, "foo", params);
            }),
        };
    }
    fetchState() {
        return __awaiter(this, void 0, void 0, function* () {
            return fetchContractState(Empty, this);
        });
    }
}
